import script from "./Buy_activationcode.vue?vue&type=script&setup=true&lang=js"
export * from "./Buy_activationcode.vue?vue&type=script&setup=true&lang=js"

import "./Buy_activationcode.vue?vue&type=style&index=0&id=efac4b28&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efac4b28"]])

export default __exports__